module.exports = __webpack_public_path__ + "media/images/emblems/Nunningen-blason-cd1786831d835c8aab00481bffa80c08.png";